import { useSelector } from 'react-redux';
import { languagesSelector } from 'slices/language.slice';
import type { TAltDesignations, TLanguage } from '@timeedit/types/lib/types';
import { Icon, TEInput } from '@timeedit/ui-components';
import { Button, Typography } from '@timeedit/ui-components/antd';
import './AltDesignationsRow.scss';

type AltDesignationRowProps = {
  altDesignation: TAltDesignations;
  onChange: (newAltDesignation: TAltDesignations) => void;
  onDelete: () => void;
  displayDescription: boolean;
};
export const AltDesignationRow = ({
  altDesignation,
  onChange,
  onDelete,
  displayDescription,
}: AltDesignationRowProps) => {
  const allLanguages = useSelector(languagesSelector);
  const languageMap = allLanguages.reduce((acc: any, curr: TLanguage) => {
    acc[curr.id] = curr;
    return acc;
  }, []);
  const _lang = languageMap[altDesignation?.language];
  return displayDescription ? (
    <div className="alt-designation-row-with-description">
      <div className="alt-designation-row-with-description-header">
        <Typography.Text strong>{_lang?.name}</Typography.Text>
        <Button
          size="small"
          type="link"
          icon={<Icon id="DeleteOutlined" alt="Delete" onClick={onDelete} />}
          onClick={onDelete}
        />
      </div>
      <div className="alt-designation-row-with-description-row">
        <Typography.Text>Display name:</Typography.Text>
        <TEInput.Input
          placeholder="Enter display name"
          wrapperStyle={{ flexBasis: 0, flexGrow: 1 }}
          value={altDesignation?.name}
          onChange={(e) => onChange({ ...altDesignation, name: e })}
        />
      </div>
      <div className="alt-designation-row-with-description-row">
        <Typography.Text>Description:</Typography.Text>
        <TEInput.TextArea
          wrapperStyle={{ flexBasis: 0, flexGrow: 1 }}
          rows={2}
          value={altDesignation?.description}
          onChange={(e) => onChange({ ...altDesignation, description: e })}
        />
      </div>
    </div>
  ) : (
    <div className="alt-designation-row-without-description">
      <Typography.Text strong>{_lang?.name}:</Typography.Text>
      <TEInput.Input
        placeholder="Enter display name"
        wrapperStyle={{ flexBasis: 0, flexGrow: 1 }}
        value={altDesignation?.name}
        onChange={(e) => onChange({ ...altDesignation, name: e })}
      />
      <Button
        size="small"
        type="link"
        icon={<Icon id="DeleteOutlined" alt="Delete" onClick={onDelete} />}
        onClick={onDelete}
      />
    </div>
  );
};
